import themeGet from '@styled-system/theme-get';
import styled from '@emotion/styled';

export const StyledSiteContent = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  box-shadow: 0 30px 50px rgb(0 0 0 / 10%);

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    margin-top: -128px;
    padding-top: 128px;
  }
`;

export const StyledSiteWrapper = styled.div`
  max-width: 1600px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    .ReactModal__Body--open & {
      display: none;
      transform: translateX(-3000px);
    }
  }
`;
